import { camelizeKeys, convertAttributesToBoolean, mapKeysToCamelCase } from '@skytech/utils'

import type { Department, PolicyOriginal } from '@/types'
import { get } from '@/util/auth'

import { API_ROUTE_ECOM_POLICY, API_ROUTE_ECOM_POLICY_CUSTOMER_DEPARTMENTS } from './api-routes'

export const commonEcomPolicyResources = {
  getList: async () => {
    const policies = await get<PolicyOriginal[]>(API_ROUTE_ECOM_POLICY)
    const camelCasePolicies = mapKeysToCamelCase(policies)
    const parsedPolicies = camelCasePolicies.map(policy =>
      convertAttributesToBoolean(policy, 'isGlobal')
    )

    return parsedPolicies
  },
  getCustomerDepartmentList: async (customerId: number) => {
    const departments = await get<unknown>(
      API_ROUTE_ECOM_POLICY_CUSTOMER_DEPARTMENTS.replace(':customerId', String(customerId))
    )
    const parsedDepartments = camelizeKeys(departments)

    return parsedDepartments as Department[]
  },
}

export type Policy = Awaited<ReturnType<typeof commonEcomPolicyResources.getList>>[number]
